/**
 * RoomCodeBadge.js
 * 
 * Shows the room code (top-left, under the navbar) so the host can share it.
 * Clicking it copies the code.
 */

import React from "react";
import { Copy } from "lucide-react";
import toast from "react-hot-toast";

const RoomCodeBadge = ({ roomID }) => {
    const code = roomID.toUpperCase();

    const copyCode = async () => {
        try {
            await navigator.clipboard.writeText(code);
            toast.success("Room code copied");
        } catch (error) {
            toast.error("Couldn't copy the code");
        }
    };

    return (
        <button
            onClick={copyCode}
            className="fixed top-20 left-6 z-40 inline-flex items-center gap-3 rounded-xl border border-zinc-700 bg-zinc-950/90 px-4 py-2 text-white backdrop-blur hover:border-zinc-500 transition-colors"
        >
            <span className="text-xs uppercase tracking-widest text-zinc-400">Room</span>
            <span className="font-mono text-lg font-bold tracking-[0.2em]">{code}</span>
            <Copy size={16} className="text-zinc-400" />
        </button>
    );
};

export default RoomCodeBadge;
